const decodeJwt = <T = Record<string, any>>(token?: string): T | null => {
  if (!token) return null
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const payload = JSON.parse((atob(parts[1])))
    return payload as T
  } catch {
    return null
  }
}

export const getTenantFromAccessToken = (token: string): string | null => {
    const payload = decodeJwt<Record<string, any>>(token)
    const tenantClaim =
      payload?.tenant ?? payload?.[`${process.env.AUTH0_NAMESPACE}/tenant`] ?? null
    return typeof tenantClaim === 'string' ? tenantClaim : null
}
